var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90597 1.91879L10.286 0.722128C10.3333 0.715343 10.3815 0.718805 10.4273 0.732278C10.4731 0.745751 10.5156 0.76892 10.5517 0.800216C10.5878 0.831512 10.6167 0.870203 10.6365 0.913666C10.6564 0.95713 10.6666 1.00435 10.6666 1.05213V14.9495C10.6666 14.9972 10.6564 15.0443 10.6366 15.0877C10.6168 15.1311 10.5879 15.1698 10.5519 15.2011C10.5158 15.2324 10.4735 15.2556 10.4278 15.2691C10.382 15.2826 10.3339 15.2861 10.2866 15.2795L1.90531 14.0828C1.74639 14.0602 1.60097 13.9809 1.49577 13.8597C1.39057 13.7385 1.33264 13.5833 1.33264 13.4228V2.57879C1.33264 2.41827 1.39057 2.26314 1.49577 2.14189C1.60097 2.02064 1.74705 1.94143 1.90597 1.91879ZM2.66664 3.15746V12.8441L9.33331 13.7968V2.20479L2.66664 3.15746ZM11.3333 12.6675H13.3333V3.33413H11.3333V2.00079H14C14.1768 2.00079 14.3464 2.07103 14.4714 2.19606C14.5964 2.32108 14.6666 2.49065 14.6666 2.66746V13.3341C14.6666 13.5109 14.5964 13.6805 14.4714 13.8055C14.3464 13.9306 14.1768 14.0008 14 14.0008H11.3333V12.6675ZM6.79998 8.00079L8.66664 10.6675H7.06664L5.99998 9.14346L4.93331 10.6675H3.33331L5.19998 8.00079L3.33331 5.33413H4.93331L5.99998 6.85813L7.06664 5.33413H8.66664L6.79998 8.00079Z",
    fill: "#393945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExel);
export default __webpack_public_path__ + "static/media/exel.29ec741a.svg";
export { ForwardRef as ReactComponent };